module.exports = __webpack_public_path__ + "static/media/materialui.82291019.svg";